import { authApi } from "api/common.service";

export const getPage = async (page: string) => {
  const response = await authApi.post("getPage", { page });
  return response ?? {};
};

export const updatePage = async (page: string, markup: string) => {
  const response = await authApi.post("updatePage", {
    page,
    markup,
  });

  return response ?? {};
};

//export default new PageService();
